import React from "react";

import "./CSS/Loader.css";

const Loader = () => {
  return (
    
    <div class="loaderContainer">
      <div class="loading">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
